import { faArrowDown, faArrowUp, faUser, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const CommentSection = () => {
  const [viewAll, setViewAll] = useState(false);
 const engagements = useSelector((store)=> store?.certificateVerification?.engagements);
  const variant = useSelector((store)=> store?.certificateVerification?.userType);
  const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);

  const getTime = (timestamp) => {
    const now = new Date();
    const inputDate = new Date(timestamp);

    // Check if the timestamp is valid
    if (isNaN(inputDate.getTime())) {
      return "Invalid date";
    }

    const diffInMs = now - inputDate;

    // If the timestamp is in the future
    if (diffInMs < 0) {
      return "In the future";
    }

    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30.44); // Average days in a month
    const years = Math.floor(days / 365.25); // Account for leap years

    if (seconds < 60) {
      return seconds === 1 ? "1 sec ago" : `${seconds} secs ago`;
    } else if (minutes < 60) {
      return minutes === 1 ? "1 min ago" : `${minutes} mins ago`;
    } else if (hours < 24) {
      return hours === 1 ? "1 hr ago" : `${hours} hrs ago`;
    } else if (days < 7) {
      return days === 1 ? "1 day ago" : `${days} days ago`;
    } else if (weeks < 4) {
      return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
    } else if (months < 12) {
      return months === 1 ? "1 month ago" : `${months} months ago`;
    } else {
      return years === 1 ? "1 year ago" : `${years} years ago`;
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-start gap-4">
        {engagements?.comments?.map((comment, index) => {
          if (!viewAll) {
            if(index <=0){
            return (
              <div className="flex w-full items-center justify-start gap-2">
                {comment?.profile_image ? <img
                  className="h-[36px] w-[36px] md:h-[44px] md:w-[44px] rounded-full "
                  width={36}
                  height={36}
                  alt=""
                  src={comment?.profile_image}
                /> : <FontAwesomeIcon className="w-[36px] h-[36px] md:h-[44px] md:w-[44px] rounded-full text-white"  icon={faUserCircle}/>}
                <div className="flex flex-col items-start justify-start">
                  <div className="flex items-center justify-start gap-1 leading-none">
                    <span className="text-[14px] md:text-[16px]  font-semibold text-white">
                      {comment?.user_name}
                    </span>
                    <span className="h-1 w-1 rounded-full bg-[#4285F4]"></span>
                    <span className="text-[10px] font-normal text-white/50">
                      {getTime(comment?.created_at)}
                    </span>
                  </div>
                  <div className="mt mt-2 text-left text-[12px] md:text-[14px] font-normal leading-[140%] text-white">
                    {comment?.user_comment}
                  </div>
                </div>
              </div>
            );
          }
          else{
            return <></>
          }

          } else {
             return (
              <div className="flex w-full items-center justify-start gap-2">
                 {comment?.profile_image ? <img
                  className="h-[36px] w-[36px] md:h-[44px] md:w-[44px] rounded-full "
                  width={36}
                  height={36}
                  alt=""
                  src={comment?.profile_image}
                /> : <FontAwesomeIcon className="w-[36px] h-[36px] md:h-[44px] md:w-[44px] rounded-full text-white"  icon={faUserCircle}/>}
                <div className="flex flex-col items-start justify-start">
                  <div className="flex items-center justify-start gap-1 leading-none">
                    <span className="text-[14px] md:text-[16px] font-semibold text-white">
                      {comment?.user_name}
                    </span>
                    <span className="h-1 w-1 rounded-full bg-[#4285F4]"></span>
                    <span className="text-[10px] font-normal text-white/50">
                      {getTime(comment?.created_at)}
                    </span>
                  </div>
                  <div className="mt mt-2 text-left text-[12px] md:text-[14px] font-normal leading-[140%] text-white">
                    {comment?.user_comment}
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
      {engagements?.comments?.length > 0 && (

        !viewAll ? 
        <div
          className="mt-3 flex cursor-pointer items-center justify-start gap-1 text-[10px] md:text-[12px] font-semibold leading-none text-[#83BEFF]/50"
          onClick={(e) => {
            
            if(variant === "owner"){
            Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_VIEW_ALL_COMMENTS_BUTTON_CLICKED, { distinct_id: userDetails?.email, insertid: userDetails?.id });
           }
           else if(variant === "recruiter"){
             Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_VIEW_ALL_COMMENTS_BUTTON_CLICKED, { distinct_id: userDetails?.email, insertid: userDetails?.id });
           }
           else{
             Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_VIEW_ALL_COMMENTS_BUTTON_CLICKED, { distinct_id: userDetails?.email, insertid: userDetails?.id });
           }
           
           setViewAll(true)}}
        >
          <FontAwesomeIcon icon={faArrowDown} size="lg" />
          <span className="underline underline-offset-2">
            View All Comments
          </span>
        </div> :
        <div
          className="mt-3 flex cursor-pointer items-center justify-start gap-1 text-[10px] md:text-[12px] font-semibold leading-none text-[#83BEFF]/50"
          onClick={(e) => {
            
          setViewAll(false)}}
        >
          <FontAwesomeIcon icon={faArrowUp} size="lg" />
          <span className="underline underline-offset-2">
            Hide 
          </span>
        </div>
      )}
    </div>
  );
};

export default CommentSection;
